// extracted by mini-css-extract-plugin
export default {"active":"Nav_active__ZP1o9"};